module.exports = __webpack_public_path__ + "img/cc1.f2f78e98.jpg";